"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const master_repository_1 = require("./master.repository");
const constants_1 = require("../../../../service-lib/src/lib/constants");
let MasterService = class MasterService {
    constructor(masterRepository) {
        this.masterRepository = masterRepository;
    }
    /**
     * Retrieves all LookUps by delegating the repository.
     */
    async getAllRecords(entityClass, search, searchId, sortBy, searchBy, sortOrder = "ASC", page = constants_1.DEFAULT_VALUES.PAGE, limit = constants_1.DEFAULT_VALUES.LIMIT) {
        try {
            return await this.masterRepository.getAllRecords(entityClass, search, searchId, sortBy, searchBy, sortOrder, page, limit);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to retrieve records");
        }
    }
    /**
     * Retrieves a single record using ID by delegating the repository.
     */
    async getRecordById(entityClass, id) {
        try {
            return await this.masterRepository.getRecordById(entityClass, id);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to retrieve record");
        }
    }
    /**
     * Creates a new record by delegating the repository.
     */
    async createRecord(entityClass, data) {
        try {
            return await this.masterRepository.createRecord(entityClass, data);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to create record");
        }
    }
    /**
     * Updates an existing record by ID for the specified entity by delegating the repository.
     */
    async updateRecordById(entityClass, id, data) {
        try {
            return await this.masterRepository.updateRecordById(entityClass, id, data);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to update record");
        }
    }
    /**
     * Deletes a record using the ID delegating the repository.
     */
    async deleteRecordById(entityClass, id) {
        try {
            await this.masterRepository.deleteRecordById(entityClass, id);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(error instanceof Error ? error.message : "Failed to delete record");
        }
    }
};
exports.MasterService = MasterService;
exports.MasterService = MasterService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof master_repository_1.MasterRepository !== "undefined" && master_repository_1.MasterRepository) === "function" ? _a : Object])
], MasterService);
